namespace Roodik.Game
{
	import ViewBase = Roodik.Core.ViewBase;
	import IGameResources = Roodik.Core.IGameResources;
	import ISoundManager = Roodik.Core.ISoundManager;
	import Tween = Roodik.Core.Tween.Tween;
	import Easing = Roodik.Core.Tween.Easing;
	import LocalizationManager = Roodik.Core.LocalizationManager;
	import IAnalytics = Roodik.Core.IAnalytics;

	export class GameCompletePanel extends ViewBase
	{
		public static readonly TRY_AGAIN: string = "GameCompletePanel.TRY_AGAIN";
		public events: PIXI.utils.EventEmitter;

		private _stop:boolean = false;
		private _closeButton : SimpleButton;
		private _message:PIXI.Text;
		private _bonusText:PIXI.Text;
		private _bonusValue:PIXI.Text;
		private _timeBonusDescription:PIXI.Text;
		private _chainBonusDescription:PIXI.Text;
		private _scoreDescription:PIXI.Text;
		private _piastresTitle:PIXI.Text;
		private _piastresCount:PIXI.Text;

		constructor(private _localizationManager:LocalizationManager,
		            private _totalScore,
		            private _timeBonus,
		            private _chainBonus,
					private _resources:IGameResources,
		            private _soundManager:ISoundManager,
		            private _analytics:IAnalytics)
		{
			super("GameCompletePanel");

			this._analytics.sendEvent("Game","Complete","");

			this.playChildAnimation("BonusPiastresAnimationView", "animtion0");
			this.stopChildAnimation("BonusPiastresAnimationView", "animtion0");

			this._piastresTitle = new PIXI.Text(this._localizationManager.getString(LocalizationKey.PIASTRES),
			this.titleStyle(36, ['#FFA500', '#FFD700'], '#8B0000'));
			this._piastresTitle.x = -this._piastresTitle.width*0.5;
			this._piastresTitle.y = -190;
			this.addChild(this._piastresTitle);

			// let desc1 = this._localizationManager.getString(LocalizationKey.FROM_CAPTAIN) + this._timeBonus.toLocaleString();
			this._timeBonusDescription = new PIXI.Text("",
			this.titleStyle(32, '#ffffff', '#000000', "left",1));
			this._timeBonusDescription.x = -220;//-this._timeBonusDescription.width*0.5;
			this._timeBonusDescription.y = -30;
			this._timeBonusDescription.alpha = 0;
			this.addChild(this._timeBonusDescription);
			this.addDotsBetweenValue(this._timeBonusDescription, this._localizationManager.getString(LocalizationKey.FROM_CAPTAIN), this._timeBonus.toLocaleString());

			// let desc2 = this._localizationManager.getString(LocalizationKey.ACCURACY) + this._chainBonus.toLocaleString();
			this._chainBonusDescription = new PIXI.Text("",
			this.titleStyle(32, ['#ffffff', ], '#000000', "left",1));
			this._chainBonusDescription.x = -220;//-this._chainBonusDescription.width*0.5;
			this._chainBonusDescription.y = 30;
			this._chainBonusDescription.alpha = 0;
			this.addChild(this._chainBonusDescription);
			this.addDotsBetweenValue(this._chainBonusDescription, this._localizationManager.getString(LocalizationKey.ACCURACY), this._chainBonus.toLocaleString());

			// let desc3 = this._localizationManager.getString(LocalizationKey.FOUND) + (this._totalScore - this._chainBonus - this._timeBonus).toLocaleString();
			this._scoreDescription = new PIXI.Text("",
			this.titleStyle(32, '#ffffff', '#000000', "left",1));
			this._scoreDescription.x = -220;//-this._chainBonusDescription.width*0.5;
			this._scoreDescription.y = 90;
			this._scoreDescription.alpha = 0;
			this.addChild(this._scoreDescription);
			this.addDotsBetweenValue(this._scoreDescription, this._localizationManager.getString(LocalizationKey.FOUND), (this._totalScore - this._chainBonus - this._timeBonus).toLocaleString());

			this.events = new PIXI.utils.EventEmitter();

			this.y = 1500;

			this._bonusValue = new PIXI.Text("+"+this._timeBonus.toLocaleString()+" "+this._localizationManager.getString(LocalizationKey.PIASTRES_1),
			this.titleStyle(60, ['#FFA500', '#FFD700'], '#ffffff'));
			this._bonusValue.x = -this._bonusValue.width*0.5;
			this._bonusValue.y = -1500;
			this.addChild(this._bonusValue);

			this._bonusText = new PIXI.Text(this._localizationManager.getString(LocalizationKey.AWARD_FROM_SMALLETT),
			this.titleStyle(85, ['#FFA500', '#FFD700'], '#8B0000'));
			this._bonusText.x = -this._bonusText.width*0.5;
			this._bonusText.y = -1630;
			this.addChild(this._bonusText);

			this._bonusText.alpha = 0;
			this._bonusValue.alpha = 0;
			this.showBonus();
		}

		private showBonus()
		{
			this._soundManager.playSound("levelComplete.wav", 1);
			let properties = {alpha:0};

			new Tween({})
			.to({}, 150)
			.easing(Easing.Quadratic.In)
			.onComplete(()=>{

				new Tween(properties)
				.to({alpha: 1}, 150)
				.easing(Easing.Quadratic.In)
				.onUpdate(()=>{
					this._bonusText.alpha = properties.alpha;
				})
				.onComplete(()=>{

					properties = {alpha:0};
					new Tween(properties)
					.to({alpha: 1}, 150)
					.easing(Easing.Quadratic.In)
					.onUpdate(()=>{
						this._bonusValue.alpha = properties.alpha;
					})
					.onComplete(()=>{
						new Tween({})
						.to({}, 3000)
						.easing(Easing.Quadratic.In)
						.onComplete(()=>{this.show();})
						.start();
					})
					.start();

				})
				.start();

			})
			.start();
		}

		private totalScore(score:number)
		{
			this._piastresCount = new PIXI.Text(score.toLocaleString(), {
				fontFamily: 'WellWait',
				fontSize: 60,
				fill: '#FFDEAD',//['#ffffff', '#4a1850'], // gradient
				stroke: '#000000',
				strokeThickness: 1,
				align:"center",
				dropShadow: true,
				dropShadowColor: '#000000',
				dropShadowBlur: 2,
				dropShadowAngle: Math.PI / 4,
				dropShadowDistance: 1,

				padding:20
			});
			this._piastresCount.x = -this._piastresCount.width*0.5;
			this._piastresCount.y = this._piastresTitle.y + 45;
			this.addChild(this._piastresCount);
		}

		private show()
		{
			this.alpha = 0;
			this.y = 300;

			this.totalScore(this._totalScore);

			this._soundManager.playSound("success.mp3", 1);

			this._closeButton = new SimpleButton(this.childByName("NextLevel").display,
			this._localizationManager.getString(LocalizationKey.BUTTON_TRY_AGAIN), {
				fontFamily: 'WellWait',
				fontSize: 32,
				fill: '#FFDEAD',//['#ffffff', '#4a1850'], // gradient
				stroke: '#000000',
				strokeThickness: 1,
				align:"center",
				dropShadow: true,
				dropShadowColor: '#000000',
				dropShadowBlur: 2,
				dropShadowAngle: Math.PI / 4,
				dropShadowDistance: 1,

				padding:20
			});
			this._closeButton.events.on(SimpleButton.CLICKED, this.hide.bind(this));
			this._closeButton.alpha = 0;

			this._message = new PIXI.Text(this._localizationManager.getString(LocalizationKey.YOHOHO),
			this.titleStyle(80, ['#FFA500', '#FFD700'], '#ffffff'));
			this._message.x = -this._message.width*0.5;
			this._message.y = -355;
			this.addChild(this._message);

			let properties = {alpha:this.alpha, y:this.y};
			new Tween(properties)
			.to({alpha: 1, y: 0}, 150)
			.easing(Easing.Quadratic.In)
			.onUpdate(()=>{
				this.alpha = properties.alpha;
				this.y = properties.y;
			})
			.onComplete(()=>{
				this.showDescription();
				this.playChildAnimation("BonusPiastresAnimationView", "animtion0", ()=>{
					this.stopChildAnimation("BonusPiastresAnimationView", "animtion0", 13);
				});
			})
			.start();
		}

		private showDescription()
		{
			let properties = {alpha:0};

			new Tween({})
			.to({}, 500)
			.easing(Easing.Quadratic.In)
			.onComplete(()=>{


				new Tween(properties)
				.to({alpha: 1}, 150)
				.easing(Easing.Quadratic.In)
				.onUpdate(()=>{
					this._timeBonusDescription.alpha = properties.alpha;
				})
				.onComplete(()=>{

					properties = {alpha:0};
					new Tween(properties)
					.to({alpha: 1}, 150)
					.easing(Easing.Quadratic.In)
					.onUpdate(()=>{
						this._chainBonusDescription.alpha = properties.alpha;
					})
					.onComplete(()=>{

						properties = {alpha:0};
						new Tween(properties)
						.to({alpha: 1}, 150)
						.easing(Easing.Quadratic.In)
						.onUpdate(()=>{
							this._scoreDescription.alpha = properties.alpha;
						})
						.onComplete(()=>{

							properties = {alpha:0};
							new Tween(properties)
							.to({alpha: 1}, 150)
							.easing(Easing.Quadratic.In)
							.onUpdate(()=>{
								this._closeButton.alpha = properties.alpha;
							})
							.onComplete(()=>{

							})
							.start();

						})
						.start();
					})
					.start();

				})
				.start();


			}).start();
		}

		private hide()
		{
			this._soundManager.playSound("click.mp3", 1);

			let properties = {alpha:this.alpha,y:this.y};
			new Tween(properties)
			.to({alpha: 0, y: -300}, 150)
			.easing(Easing.Quadratic.Out)
			.onUpdate(()=>{
				this.alpha = properties.alpha;
				this.y = properties.y;
			})
			.onComplete(function ()
			{
				this.goToNextLevel();
			}.bind(this))
			.start();
		}

		private goToNextLevel()
		{
			this._stop = true;
			this.events.emit(GameCompletePanel.TRY_AGAIN);
		}
		
		private addDotsBetweenValue(view:PIXI.Text, title:string, value:string)
		{
			let maxSize:number = 430;
			let difference = maxSize - view.width;
			let dotCount:number = 1;
			while(difference > 0)
			{
				let dots:string = "";
				for(let i:number = 0; i < dotCount; i++)
				{
					dots += ".";
				}
				view.text = title + " "+ dots +" " + value;
				dotCount++;
				difference = maxSize - view.width;
			}
		}

		private titleStyle(fontSize:number, fillColor:any, strokeColor:string, align:string = "center", strokeThickness:number = 5)
		{
			return {
				fontFamily: 'WellWait',
				fontSize: fontSize,
				fontStyle: 'italic',
				fontWeight: 'bold',
				fill: fillColor,//'#FFD700',//['#FFD700', '#4a1850'], // gradient
				stroke: strokeColor,//'#ffffff',//'#338d13',
				strokeThickness: 5,
				align:align,
				dropShadow: true,
				dropShadowColor: strokeColor,//'#ffffff',
				dropShadowBlur: 1,
				dropShadowAngle: Math.PI / 4,
				dropShadowDistance: 1,

				padding:20
			}
		}

		public destroy()
		{
			this.removeChild(this._scoreDescription);
			this.removeChild(this._chainBonusDescription);
			this.removeChild(this._timeBonusDescription);
			this.removeChild(this._bonusValue);
			this.removeChild(this._bonusText);
			this.removeChild(this._message);
			this.removeChild(this._piastresTitle);
			this.removeChild(this._piastresCount);
			this._scoreDescription.destroy();
			this._chainBonusDescription.destroy();
			this._timeBonusDescription.destroy();
			this._bonusValue.destroy();
			this._bonusText.destroy();
			this._message.destroy();
			this._piastresTitle.destroy();
			this._piastresCount.destroy();
			this._closeButton.events.off(SimpleButton.CLICKED, this.goToNextLevel.bind(this));
			super.destroy();
		}
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Game/View/GameCompletePanel.ts